import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setVisible(window.scrollY > 400);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      onClick={scrollUp}
      aria-label="Scroll to top"
      className={`fixed bottom-8 left-8 z-50 w-11 h-11 rounded-xl flex items-center justify-center text-white transition-all duration-500 cursor-pointer active:scale-90 hover:scale-110 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      style={{
        background: 'linear-gradient(135deg, #06b6d4, #3b82f6, #8b5cf6)',
        boxShadow: '0 4px 16px rgba(6, 182, 212, 0.35), 0 0 24px rgba(59, 130, 246, 0.15)',
        border: '1px solid rgba(6, 182, 212, 0.3)',
      }}
    >
      <ArrowUp className="w-4.5 h-4.5" />
    </button>
  );
}
